import { render, staticRenderFns } from "./RepairForm.vue?vue&type=template&id=60a59349&scoped=true"
import script from "./RepairForm.vue?vue&type=script&lang=js"
export * from "./RepairForm.vue?vue&type=script&lang=js"
import style0 from "./RepairForm.vue?vue&type=style&index=0&id=60a59349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a59349",
  null
  
)

export default component.exports